<template>
  <div id="pageRoot">

    <span class="normalTheme pageInstruction" style="left: 55px; top: 55px;">
      <p>Di en voz alta el nombre de cada animal marcando las sílabas con golpes.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 95px;">
      <p>Tacha el dibujo cuyo nombre no tiene la misma cantidad de sílabas.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 135px;">
      <p>Dibújalo y subelo en el cuadro que aparece a la derecha.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 175px;">
      <p>Escribe el nombre del animal dibujado.</p>
    </span>

    <label class="imageRadioButton">
    <input type="radio" name="1" value="Araña"
    ref="1-1" 
    v-on:change="saveOption('radios', 1, 1)" 
    :onload="loadOption('radios', 1, 1)"
    >
      <span class="checkmark" style="margin-left: 70px; margin-top: 275px; width: 204px; height: 170px">
        <img class="image" src="/pages/img/sordovio/assets_p21/spider.svg">
      </span>
    </label>

    <label class="imageRadioButton">
    <input type="radio" name="1" value="Oso"
    ref="1-2" 
    v-on:change="saveOption('radios', 1, 2)" 
    :onload="loadOption('radios', 1, 2)"
    >
      <span class="checkmark" style="margin-left: 315px; margin-top: 275px; width: 204px; height: 170px">
        <img class="image" src="/pages/img/sordovio/assets_p21/bear.svg">
      </span>
    </label>

    <label class="imageRadioButton">
    <input type="radio" name="1" value="Jirafa"
    ref="1-3" 
    v-on:change="saveOption('radios', 1, 3)" 
    :onload="loadOption('radios', 1, 3)"
    >
      <span class="checkmark" style="margin-left: 70px; margin-top: 475px; width: 204px; height: 170px">
        <img class="image" src="/pages/img/sordovio/assets_p21/giraffe.svg">
      </span>
    </label>

    <label class="imageRadioButton">
    <input type="radio" name="1" value="Saltamontes"
    ref="1-4" 
    v-on:change="saveOption('radios', 1, 4)" 
    :onload="loadOption('radios', 1, 4)"
    >
      <span class="checkmark" style="margin-left: 315px; margin-top: 475px; width: 204px; height: 170px">
        <img class="image" src="/pages/img/sordovio/assets_p21/cricket.svg">
      </span>
    </label>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />

    <uploaded-image
      class="image01 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
    ></uploaded-image>

    <div id="button01" style="position: absolute; z-index: 5">
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
      ></image-upload>
    </div>
  </div>
</template>
<style scoped>
#inputField01 {
  position: absolute;
  width: 245px;
  height: 36px;
  left: 623px;
  top: 260px;
  z-index: 5;
}
.image01 {
  position: absolute;
  width: 298px;
  height: 369px;
  left: 606px;
  top: 281px;
}
#button01 {
  width: 216px;
  height: 77px;
  left: 655px;
  top: 615px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, group){
        return `${this.$parent.type}-${this.$parent.page}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>